import type { TrackingProps } from '@seek/tealium-adapter/lib-types/types';
import { Link, TextLink } from 'braid-design-system';
import type React from 'react';

import { useTracking } from 'src/hooks/useTracking';

interface TrackingLinkProps {
  href: string;
  className?: string;
  onClick?: () => void;
  eventName?: string;
  eventAttributes?: TrackingProps;
  weight?: React.ComponentProps<typeof TextLink>['weight'];
  target?: string;
  intercomid?: string;
  testId?: string;
}

export const TrackingLink: React.FunctionComponent<
  React.PropsWithChildren<TrackingLinkProps>
> = ({
  onClick,
  eventName,
  eventAttributes,
  intercomid,
  testId,
  weight,
  ...restProps
}) => {
  const { trackEvent } = useTracking();

  const handleClick = () => {
    if (eventName) {
      trackEvent(eventName, eventAttributes);
    }

    onClick?.();
  };

  if (weight) {
    return (
      <TextLink
        data-intercomid={intercomid}
        data-testid={testId}
        {...restProps}
        onClick={handleClick}
        weight={weight}
      />
    );
  }

  return <Link {...restProps} onClick={handleClick} />;
};
